module.exports = __webpack_public_path__ + "img/Skorzewski_carton.1b633dba.png";